<template>
	<div>
		<div class="device-mobile" v-if="isMobile">
			<div class="main">
				<div class="navbar">
					<img @dragstart.prevent src="@/assets/001.png" alt="" class="logo" @click="toTopImg(0)" />
					<img @dragstart.prevent src="@/assets/002.png" alt="" class="search" />
					<img @dragstart.prevent src="@/assets/003.png" alt="" class="menu" @click="isMenuShow = true" />
				</div>
				<div class="navbar-placeholder"></div>
				<div class="banner" style="width: 100vw; height: 53.333333vw" v-if="count == 0">
					<el-carousel trigger="click" height="53.333333vw">
						<el-carousel-item v-for="(item, index) in bannerImgList" :key="index"
							style="height: 53.333333vw">
							<img @dragstart.prevent :src="webImg + item.bannerImg + imgCut(1000, 530, 'r')" alt=""
								srcset="" style="width: 100vw;!important; height:53.333333vw;object-fit: fill;" />
						</el-carousel-item>
					</el-carousel>
				</div>
				<div v-if="$route.query.index == 1 || $route.query.index == 6">
					<div style="width: 100vw; height: 45.066666vw">
						<img @dragstart.prevent
							v-if="navBarList[$route.query.index] && navBarList[$route.query.index].frontImg"
							:src="webImg + navBarList[$route.query.index].frontImg + imgCut(1000, 450)" alt=""
							style="width: 100vw; height: 45.066666vw" />
					</div>
				</div>
				<router-view />
				<div class="foot">
					<img @dragstart.prevent src="../../src/assets/footBanner.png" alt="" class="footTwoImg" />
					<div class="footFour">
						<div class="row-1" style="cursor: pointer">
							<a @click="copyrightClick()">版权声明</a>
							<div class="line">｜</div>
							<a @click="navBarClick(contractUsObj)" style="cursor: pointer">联系我们</a>
						</div>
						<div class="row-2">版权所有:国机通用机械科技股份有限公司</div>
						<div>
							<a href="https://beian.miit.gov.cn/#/Integrated/index">备案序号:皖ICP备14018836号</a>
							<a href="https://www.beian.gov.cn/portal/registerSystemInfo?recordcode=34019102000037"
								style="margin-left: 10px">皖公网安备 34019102000037号</a>
						</div>
					</div>
					<div class="menu-modal" v-if="isMenuShow" @click="isMenuShow = false">
						<div class="menu-modal-content" @click.stop>
							<div class="header">
								<img @dragstart.prevent src="@/assets/home.png" alt="" class="home"
									@click="toTopImg(0)" />
								<div class="txt" @click="toTopImg(0)">首页</div>
								<div class="close" @click="isMenuShow = false"><i class="el-icon-close"></i></div>
							</div>
							<div class="menu-list">
								<div class="yiji-item" v-for="(item, index) in navBarList" :key="index">
									<div class="content" @click="navMouseEnter(item)">
										<img @dragstart.prevent src="@/assets/004.png" alt="" class="dot" />
										<div class="title">{{ item.menuName }}</div>
										<img @dragstart.prevent src="@/assets/006.png" alt="" class="arrow-down"
											v-if="index == enterCount && chooseMenuList[index].length" />
										<img @dragstart.prevent src="@/assets/005.png" alt="" class="arrow-right"
											v-else />
									</div>
									<div class="erji-item" v-if="enterCount == index"
										v-for="(item1, index1) in chooseList" @click.stop="chooseClick(index1)">
										<div class="txt" v-if="index != 2">{{ item1.menuName }}</div>
										<div class="txt" v-else>{{ item1.title }}</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="device-pc" v-else>
			<div class="main">
				<!-- 顶部LOGO区域 -->
				<div class="top">
					<img src="../assets/topLeftImg.png" alt="" class="topLeftImg" @click="toTopImg(0)"
						@dragstart.prevent />
					<!-- 导航栏结构优化 -->
					<div class="nav-container">
						<div class="search-box">
							<div class="lianxi">
								<img src="../assets/phone.png" alt="" class="phone-icon" 
									@dragstart.prevent />
								<div class="label">联系人：</div>
								<div class="text">韩工 15395150883</div>
							</div>
							<div class="input-box" >
								<el-input placeholder="请输入关键词" v-model="search" @keydown.enter.native="searchInput">
									<el-button slot="append" icon="el-icon-search"></el-button>
								</el-input>
							</div>
						</div>
						<div class="nav-bar" @mouseleave="enterShow = false; enterCount = -1;">
							<div class="nav-main">
								<div class="nav-item" v-for="(item, index) in navBarList" :key="index"
									@mouseenter.stop="navMouseEnter(item)" @click="navBarClick(item)">
									<div class="nav-title">
										{{ item.menuName }}
									</div>
									<transition name="dropdown">
										<div class="nav-dropdown" v-show="enterCount == index && enterShow">
											<div class="dropdown-item" v-for="(item1, index1) in chooseList"
												:key="index1" @click.stop="chooseClick(index1)">
												{{ item1.menuName || item1.title }}
											</div>
										</div>
									</transition>
								</div>
							</div>
						</div>
					</div>
				</div>

				<div class="banner" style="width: 100%; height: 20.17vw" v-if="isActive('/home')">
					<el-carousel trigger="click" height="20.17vw">
						<el-carousel-item v-for="(item, index) in bannerImgList" :key="index" style="height: 20.17vw">
							<img @dragstart.prevent :src="webImg + item.bannerImg + imgCut(1920, 251, 'r')" alt=""
								srcset="" style="width: 100%;!important; height:20.17vw;" />
						</el-carousel-item>
					</el-carousel>
				</div>
				<div
					v-if="isActive('/aboutUs') || isActive('/newsCenter') || isActive('/construct') || isActive('/investor') || isActive('/contactUs')">
					<div style="width: 100%; height: 10.17vw">
						<img @dragstart.prevent
							v-if="navBarList[$route.query.index] && navBarList[$route.query.index].frontImg"
							:src="webImg + navBarList[$route.query.index].frontImg + imgCut(1000, 251, 'r')" alt=""
							style="width: 100%; height: 10.17vw" />
					</div>
				</div>
				<router-view />
				<div class="foot">
					<div class="footTwoImgWrapper" style="width: 100%;">
						<img style="width: 100%;" @dragstart.prevent src="../../src/assets/footBanner.png" alt=""
							class="footTwoImg" />
					</div>
					<div class="footThree">
						<div class="link">友情链接</div>
						<div style="margin-left: 40px">
							<el-select v-model="value" placeholder="相关单位" @change="change">
								<!-- <div v-infinite-scroll="load" style="overflow:auto;height: 100px;"> -->
								<el-option v-for="item in options" :key="item.id" :label="item.unitName"
									:value="item"></el-option>
								<!-- </div> -->
							</el-select>
						</div>
					</div>

					<div class="footFour">
						<div style="cursor: pointer">
							<a @click="copyrightClick()">版权声明</a>
							｜
							<a @click="navBarClick(contractUsObj)" style="cursor: pointer">联系我们</a>
						</div>
						<div>版权所有:国机通用机械科技股份有限公司</div>
						<div>
							<a href="https://beian.miit.gov.cn/#/Integrated/index">备案序号:皖ICP备14018836号</a>
							<a href="https://www.beian.gov.cn/portal/registerSystemInfo?recordcode=34019102000037"
								style="margin-left: 10px">皖公网安备 34019102000037</a>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { menu, bannerList, menuAll, unitList, unitBelowList } from '../api/api';
export default {
	name: 'mainTemplate',
	data() {
		return {
			bannerImgList: [],
			show: false,
			navBarList: [],
			// 公共头部和底部是否展示
			count: 0,
			chooseCount: -1,
			options: [],
			optionsChildren: [],
			value: '',
			valueChildren: '',
			chooseList: [],
			unitBelowList: [],
			search: '',
			enterShow: false,
			enterCount: -1,
			isMenuShow: false,
			chooseMenuList: [[], [], [], [], [], [], [], []],
			contractUsObj: {
				cmsLink: null,
				cmsRouterIndex: 7,
				cmsRouterPath: "/contactUs",
				cmsType: 0,
				frontIcon: null,
				frontImg: "/profile/upload/2025/03/31/20250331110549A045.png",
				menuId: 2141,
				menuName: "联系我们",
				path: "contact",
				query: null
			}
		};
	},
	created() {
		this.$store.commit('changeScreenWidth');
		// 监听页面尺寸
		window.addEventListener('resize', () => {
			this.$store.commit('changeScreenWidth');
		});
		// 监听页面滚动
		window.onscroll = () => {
			// 发送滚动事件
			this.$bus.$emit('windowOnscroll');

			// 监听滚动到底部
			if (this.$global.reachBottom(0)) {
				console.log('滚动到底部了');
				this.$bus.$emit('reachBottom');
			}
		};

		if (this.$route.query.index) {
			this.count = this.$route.query.index;
		}

		this.getBannerList(); //首页轮播图
		this.getMenuAll(); //首页轮播图
		this.getUnitList(); //友情链接
		this.getUnitBelowList(); //友情链接
	},

	watch: {
		$route(to, from) {
			console.log(to.query.index, 'to');
			this.count = to.query.index;
			console.log('this.count: ', this.count);
		},
		isMenuShow(val) {
			console.log('val: ', val);
			this.$global.stopPageScroll(val);
		}
	},
	methods: {
		//首页轮播图
		getBannerList() {
			bannerList().then((res) => {
				console.log(res, 'res');
				this.bannerImgList = res.data;
			});
		},
		//首页链接
		toTopImg(index) {
			if (index == 0) {
				this.$router.push({
					path: '/home',
					query: {
						index: index
					}
				});
			} else {
				location.href = 'http://www.hgmri.com/';
			}
			this.isMenuShow = false;
		},
		//查询所有菜单
		getMenuAll() {
			menuAll().then((res) => {
				this.navBarList = res.data;
				this.getMenu(1);
				this.getMenu(6);
			});
		},
		isActive(route) {
			return this.$route.path === route;
		},
		//pc端鼠标移入
		navMouseEnter(val) {
			if (this.enterCount == val.cmsRouterIndex) {
				return (this.enterCount = -1);
			}
			this.enterCount = val.cmsRouterIndex;
			this.enterShow = true;
			this.chooseList = this.chooseMenuList[val.cmsRouterIndex];
			console.log('this.chooseList: ', this.chooseList);
			if (this.isMobile) {
				console.log('11111: ', 11111);
				this.navBarClick(val)
				if (
					val.cmsRouterIndex == 0 ||
					val.cmsRouterIndex == 2 ||
					val.cmsRouterIndex == 3 ||
					val.cmsRouterIndex == 4 ||
					val.cmsRouterIndex == 5 ||
					val.cmsRouterIndex == 7
				) {
					this.isMenuShow = false;
				}
			}
		},
		//移动端鼠标点击
		// navMouseEnter(index) {
		// 	if (this.enterCount == index) {
		// 		return (this.enterCount = -1);
		// 	}
		// 	this.enterCount = index;
		// 	this.enterShow = true;
		// 	this.chooseList = this.chooseMenuList[index];
		// 	console.log('this.chooseList: ',this.chooseList);
		// },
		//查询子菜单
		getMenu(index) {
			menu(this.navBarList[index].menuId).then((res) => {
				this.chooseMenuList[index] = res.data;
			});
		},
		chooseClick(index) {
			if (this.enterCount == 1) {
				this.openUrl({
					path: '/aboutUs',
					query: {
						parentId: this.navBarList[this.enterCount].menuId,
						index: this.enterCount,
						num: index
					}
				});
			}
			if (this.enterCount == 6) {
				this.openUrl({
					path: '/newsCenter',
					query: {
						parentId: this.navBarList[this.enterCount].menuId,
						index: this.enterCount,
						num: index
					}
				});
			}
			if (this.isMobile) {
				this.isMenuShow = false
			}
		},
		searchInput(e) {
			if (this.search && e.keyCode == 13) {
				// this.openUrl({ path: '/search', query: { search: this.search } })
				this.openUrl({
					path: '/newsCenter',
					query: {
						parentId: this.navBarList[6].menuId,
						index: 2,
						num: 0,
						search: this.search
					}
				});
			}
		},

		//导航栏
		navBarClick(val) {
			console.log(val, 'val');
			if (val.cmsRouterIndex == 0) {
				this.$router.push({
					path: val.cmsRouterPath,
					query: {
						index: 0
					}
				});
			} else {
				let parsedQuery = {};
				try {
					parsedQuery = val.query ? JSON.parse(val.query) : {};
				} catch (e) {
					console.warn('val.query 解析失败:', val.query, e);
				}
				
				this.openUrl({
					path: val.cmsRouterPath,
					query: {
						id: parsedQuery.id || '', // 安全获取
						parentId: val.menuId,
						index: val.cmsRouterIndex == 7 ? 6 : val.cmsRouterIndex
					}
				});
			}
			// if (index == 0) {
			// 	this.$router.push({
			// 		path: '/home',
			// 		query: {
			// 			index: index
			// 		}
			// 	});
			// }
			// if (this.enterCount == 2 || this.enterCount == 3 || this.enterCount == 4 || this.enterCount == 5) {
			// 	this.openUrl({
			// 		path: '/vocational',
			// 		query: {
			// 			id: JSON.parse(this.navBarList[index].query).id,
			// 			index: index
			// 		}
			// 	});
			// }
			// if (index == 7) {
			// 	this.openUrl({
			// 		path: '/contactUs',
			// 		query: {
			// 			parentId: this.navBarList[index].menuId,
			// 			index: index
			// 		}
			// 	});
			// }

		},

		//友情链接
		getUnitList() {
			unitList().then((res) => {
				this.options = res.data;
			});
		},
		getUnitBelowList() {
			unitBelowList().then((res) => {
				this.optionsChildren = res.data;
			});
		},
		//底部链接
		change(e) {
			this.value = e.unitName;
			this.$confirm('是否打开链接')
				.then((_) => {
					this.done(e.unitLink);
				})
				.catch((_) => { });
		},
		done(e) {
			location.href = e;
		},
		//底部链接
		change1(e) {
			this.valueChildren = e.belowName;
			console.log(111111);
			this.$confirm('是否打开链接')
				.then((_) => {
					this.done(e.belowLink);
				})
				.catch((_) => { });
		},
		copyrightClick() {
			this.openUrl({
				path: '/copyright',
				query: {
					search: this.search,
					index: 0
				}
			});
		}
	}
};
</script>

<style scoped lang="scss">
.device-mobile {
	.main {
		display: flex;
		flex-direction: column;
		align-items: center;
		// width: 100vw;
		min-height: 100vh;
		background: #ffffff;

		.navbar {
			position: fixed;
			top: 0;
			z-index: 99;
			display: flex;
			align-items: center;
			width: 100%;
			height: 1.333333rem;
			background: #ffffff;

			.logo {
				margin-left: 0.266667rem;
				margin-right: auto;
				width: auto;
				height: 70%;
			}

			.search {
				width: 0.493333rem;
				height: 0.493333rem;
			}

			.menu {
				margin-left: 0.706667rem;
				margin-right: 0.453333rem;
				width: 0.453333rem;
				height: 0.426667rem;
			}
		}

		.navbar-placeholder {
			width: 100%;
			height: 1.333333rem;
		}

		.foot {
			margin-top: auto;

			.footOne {
				display: flex;
				flex-direction: column;
				align-items: center;
				margin-bottom: 0.613333rem;

				.footOneItem {
					margin-bottom: 0.266667rem;
					width: 9.466667rem;
					height: 3.2rem;
					position: relative;
					display: flex;
					justify-content: center;
					align-items: center;
					overflow: hidden;

					img {
						width: 100%;
						object-fit: cover;
					}

					.footText {
						position: absolute;
						font-size: 0.48rem;
						font-family: Microsoft YaHei-Bold, Microsoft YaHei;
						font-weight: bold;
						color: #ffffff;
					}

					.footOneMore {
						position: absolute;
						top: 0.266667rem;
						right: 0;
						display: flex;
						justify-content: center;
						align-items: center;
						width: 0.906667rem;
						height: 0.586667rem;
						background: #0175c2;

						a {
							font-size: 0.32rem;
							font-family: Microsoft YaHei-Regular, Microsoft YaHei;
							font-weight: 400;
							color: #ffffff;
							text-decoration: none;
						}
					}
				}
			}

			.footTwoImg {
				display: flex;
				width: 100%;
				height: 1.2rem;
			}

			.footFour {
				display: flex;
				flex-direction: column;
				justify-content: center;
				align-items: center;
				width: 100%;
				height: 1.866667rem;
				background: #1e243c;
				border-radius: 0px 0px 0px 0px;
				opacity: 1;

				div,
				a {
					font-size: 0.24rem;
					font-family: PingFang SC-Medium, PingFang SC;
					font-weight: 500;
					color: #979fbf;
					text-decoration: none;
				}

				.row-1 {
					display: flex;
					align-items: center;

					.line {
						margin: 0 0.266667rem;
					}
				}

				.row-2 {
					margin: 0.1rem 0;
				}
			}
		}

		.menu-modal {
			position: fixed;
			top: 0;
			right: 0;
			bottom: 0;
			left: 0;
			background-color: rgba(#000000, 0.5);
			z-index: 99;

			.menu-modal-content {
				width: 8rem;
				height: 100%;
				margin-left: auto;
				background: #ffffff;
				border-radius: 0px 0px 0px 0px;
				opacity: 1;
				overflow-y: auto;

				.header {
					display: flex;
					align-items: center;
					width: 100%;
					height: 2.4rem;

					.home {
						width: 0.4rem;
						height: 0.4rem;
						margin-left: 0.693333rem;
						margin-right: 0.293333rem;
					}

					.txt {
						margin-right: auto;
						font-size: 0.506667rem;
						font-family: PingFang SC-Bold, PingFang SC;
						font-weight: bold;
						color: #363b4c;
					}

					.close {
						display: flex;
						margin-right: 0.533333rem;

						.el-icon-close {
							font-size: 0.706667rem;
						}
					}
				}

				.menu-list {
					width: 100%;

					.yiji-item {
						width: 100%;

						.content {
							display: flex;
							align-items: center;
							position: relative;
							width: 100%;
							height: 1.333333rem;
							background-color: #ffffff;

							.dot {
								position: absolute;
								margin-left: 0.666667rem;
								width: 0.16rem;
								height: 0.16rem;
							}

							.title {
								margin-left: 1.013333rem;
								margin-right: auto;
								font-size: 0.453333rem;
								font-family: PingFang SC-Medium, PingFang SC;
								font-weight: 500;
								color: #363b4c;
							}

							.arrow-down {
								width: 0.373333rem;
								height: 0.32rem;
								margin-right: 0.453333rem;
							}

							.arrow-right {
								width: 0.32rem;
								height: 0.373333rem;
								margin-right: 0.453333rem;
							}
						}

						.erji-item {
							display: flex;
							align-items: center;
							width: 100%;
							height: 1.333333rem;
							background-color: #f7f7f7;

							.txt {
								margin-left: 1.013333rem;
								font-size: 0.4rem;
								font-family: PingFang SC-Medium, PingFang SC;
								font-weight: 500;
								color: #363b4c;
							}
						}
					}
				}
			}
		}
	}
}

.device-pc {
	.main {
		width: 100%;
		min-width: 1200px; // 设置最小宽度保证基本布局
		max-width: 1920px;
		margin: 0 auto;
		// overflow-x: auto;
	}

	.top {
		display: flex;
		justify-content: space-between;
		align-items: center;
		background: #fff;
		width: 100%;
		box-sizing: border-box;
		max-width: 1300px;
		margin: 0 auto;

		.topLeftImg {
			height: auto;
			max-height: 80px;
			width: auto;
		}
		
		.topRightImg {
			height: auto;
			max-height: 29px;
			width: auto;
		}
	}

	.nav-container {
		position: relative;
		background: #fff;
		max-width: 1400px; // 限制最大宽度
		// margin: 0 auto; // 居中
		// padding: 0 20px; // 添加内边距
		box-sizing: border-box;

	}

	.nav-bar {
		display: flex;
		justify-content: space-between;
		align-items: center;
		height: 60px;
		width: 100%;
		flex-wrap: nowrap;
		/* 防止内容换行 */
	}

	/* 响应式调整：当屏幕较小时，调整导航栏的布局 */
	@media (max-width: 768px) {
		.nav-bar {
			justify-content: space-around;
			/* 使项目之间有更均匀的间距 */
		}

		.nav-bar>* {
			flex-shrink: 1;
			/* 允许子元素在空间不足时缩小 */
		}
	}

	@media (max-width: 480px) {
		.nav-bar {
			flex-direction: column;
			/* 更小的屏幕时，将导航栏排列为垂直布局 */
			height: auto;
			/* 允许高度自适应 */
		}

		.nav-bar>* {
			margin-bottom: 10px;
			/* 为每个子元素添加间距 */
		}
	}


	.nav-main {
		display: flex;
		// flex-wrap: wrap; // 允许换行
		justify-content: center; // 居中导航项
	}

	.nav-item {
		position: relative;
		margin-left: 40px;
		height: 100%;
		display: flex;
		align-items: center;
		font-size: 16px;
		color: #333;
		cursor: pointer;
		white-space: nowrap;
		flex-shrink: 0;
		/* 防止导航项被压缩 */

		&:hover {
			color: #0076be;
		}

		.nav-title {
			position: relative;

			&::after {
				content: '';
				position: absolute;
				bottom: -5px;
				left: 0;
				width: 0;
				height: 2px;
				background: #0076be;
				transition: transform 0.3s ease;
				transform: scaleX(0);
				transform-origin: left;
			}

			&:hover::after {
				transform: scaleX(0);
			}
		}
	}

	.nav-dropdown {
		position: absolute;
		top: 100%;
		left: 0;
		width: 200px;
		background: #fff;
		box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
		border-radius: 4px;
		z-index: 1000;

		.dropdown-item {
			padding: 12px 20px;
			color: #666;
			font-size: 14px;
			transition: all 0.2s;

			&:hover {
				background: #f7f9fc;
				color: #0076be;
				padding-left: 24px;
			}
		}
	}

	.choose {
		// padding-top: 4px;
		width: 420px;
		// height: 100px;
		box-sizing: border-box;
		position: absolute;
		left: 0;
		top: 40px;
		z-index: 999999;
		background: #ffffff;
		display: flex;
		flex-wrap: wrap;
		font-size: 18px;
		font-family: Microsoft YaHei-Regular, Microsoft YaHei;
		font-weight: 400;
		color: #333333;

		.chooseItem {
			// margin-right: 10px;
			// margin-top: 10px;
			padding: 10px 20px;
			border-bottom: 1px dashed #e5e5e5;
			border-top: 1px dashed #e5e5e5;

			span {
				// color: aqua;
			}

			span:hover {
				text-decoration: underline;
			}
		}

		.chooseItem:last-child {
			// border-bottom: 1px dashed #e5e5e5;
		}

		.chooseItem1 {
			background: #0076be;
			color: #ffffff;
		}

		.chooseItem:hover {
			// background: #0076BE;
			// color: #FFFFFF;
		}
	}
	
	.search-box {
		padding-top: 10px;
		display: flex;
		justify-content: flex-end;
		align-items: center;
		.lianxi {
			padding: 0 33px 0 10px;
			display: flex;
			align-items: center;
			.phone-icon {
				width: 17px;
				height: 17px;
				margin-right: 10px;
			}
			.label {
				font-size: 16px;
				color: #333;
			}
			.text {
				font-size: 16px;
				color: #0996df;
				// font-weight: bold;
			}
		}

		.input-box {
			width: 280px;
			min-width: 200px; // 设置最小宽度
			/* Vue 2.x 写法 */
			::v-deep .el-input-group__append {
				background: #0076be;
				border-color: #0076be;
	
				.el-icon-search {
					color: #fff;
				}
			}
		}
	}


	.foot {
		// width: 100vw;
		// background: #FFFFFF;

		.footOne {
			width: 1200px;
			height: 290px;
			display: flex;
			align-items: center;
			margin: 0 auto;
			cursor: pointer;
			position: relative;

			.footOneMore {
				position: absolute;
				right: 30px;
				top: 60px;
				width: 43px;
				height: 28px;
				// background: #0175C2;
				background: rgba(1, 117, 194, 0.5);
				font-size: 14px;
				font-family: Microsoft YaHei-Bold, Microsoft YaHei;
				font-weight: bold;
				color: #ffffff;
				display: flex;
				justify-content: center;
				align-items: center;

				a {
					color: #ffffff;
					text-decoration: none;
				}
			}

			.footOneItem {
				position: relative;
				width: 300px;
				height: 200px;
				// background: rgba(0, 0, 0, 0.5);
				overflow: hidden;
				margin-right: 30px;
				// filter: blur(1px) grayscale(.1);
				opacity: 0.6;
				// background: rgba(255, 255, 255, .6);

				// img {
				//   transition: transform 2s cubic-bezier(.23, 1, .32, 1);
				// }
			}

			.footOneItem:hover {
				opacity: 2;
				// background: rgba(255, 255, 255, 1);

				// background: rgba(0, 0, 0, 1);

				// transform: scaleX(20%);
				// img {
				//   transition: transform 2s cubic-bezier(.23, 1, .32, 1);
				//   transform: scale(1.1);
				// }
			}

			img {
				width: 328px;
				height: 200px;
			}

			.footText {
				font-size: 20px;
				font-family: Microsoft YaHei-Bold, Microsoft YaHei;
				font-weight: bold;
				color: #ffffff;
				position: absolute;
				top: 50%;
				left: 50%;
				transform: translate(-50%, -50%);
			}
		}

		.footTwoImgWrapper {
			// width: 100vw;
			padding-top: 30px;
			background-color: #f5f5f5;
			/* 这里单独给 padding 区域设背景色 */
		}

		.footTwoImg {
			// width: 100vw;
			height: 140px;
			background-color: white;
		}


		.footThree {
			width: 1300px;
			height: 64px;
			display: flex;
			align-items: center;
			// justify-content: center;
			margin: 0 auto;

			.link {
				font-size: 18px;
				font-family: Microsoft YaHei-Regular, Microsoft YaHei;
				font-weight: 400;
				color: #004ea1;
			}
		}

		.footFour {
			// width: 100vw;
			height: 179px;
			background: #0076be;
			font-size: 14px;
			font-family: Microsoft YaHei-Regular, Microsoft YaHei;
			font-weight: 400;
			color: #ffffff;
			display: flex;
			justify-content: center;
			align-items: center;
			flex-direction: column;
			line-height: 30px;

			a {
				color: #ffffff;
				text-decoration: none;
			}
		}
	}

	.banner {
		// @media screen and (min-width: 960px) and (max-width: 1200px) {
		//   zoom: .643;
		// }
	}

	.el-carousel__container {
		height: 20.17vw !important;
		height: 5.333333rem;
	}
}

/* 动画效果 */
.dropdown-enter-active,
.dropdown-leave-active {
	transition: all 0.3s;
	transform-origin: top center;
}

.dropdown-enter,
.dropdown-leave-to {
	opacity: 0;
	transform: translateY(-10px);
}
</style>



// WEBPACK FOOTER //
// src/components/main.vue